import React, { Component } from 'react'
import Helmet from 'react-helmet'
import { StyleSheet, css } from 'aphrodite';

import Content from '../components/Content.js'
import Header from "../components/Nav.js";
import axios from 'axios';
import autoBind from 'react-autobind'
import CarWithPopups from '../components/CarWithPopups'

import './Cars.css'


export default class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      subscribe: true,
      textOnButton:"Subscribe",
      validInput: false,
      email:"",
      placeholder:"Enter your E-mail",

      shake: false,
      error: false,
      wrapperState: 0,
      buttonState:0,
      location:"home",
      logoState:false,

      active:1,
      activeGal: "",

      
    };
    autoBind(this);
  }
    

   componentWillMount(){
    setTimeout(() => {
      this.setState({wrapperState: 1,});
    },2000);  
  }

  

  componentDidMount(){

  }
    handleClick(){
    if(this.state.wrapperState === 0){
      this.setState({wrapperState: 1});
      console.log("wrapperState:1");
    } else if(this.state.wrapperState === 1){
      if(this.state.validInput){
        this.setState({wrapperState: 2, textOnButton:"THANK YOU", error: false});
        axios.post('https://digitalsurfin.com/mail1', this.state).then(response => {
            if(response.data==="250 Message received"){
              console.log(response);
            } else {
              console.log(response);
            }
          })
          .catch(error => {
            console.log(error);
          });
        console.log("wrapperState:2");
      } else {
        this.setState({shake: true, error: true});
        setTimeout(() => this.setState({ shake: false}), 500);
      }
      
    } else if(this.state.wrapperState === 2){
      
      this.setState({wrapperState: 0, textOnButton:"Subscribe", email: ""});
    }


    if(window.innerWidth > 400){
      document.getElementById("signUp").focus();
    }

    // if(this.state.subscribe === false && this.state.validInput === true){
    //  var aliJe = false;
    //  this.setState({subscribe: !this.state.subscribe, textOnButton: "THANK YOU"});
      
    // }
  }
  handleClickEnter(e){
    if (e.keyCode === 13) {
      if(this.state.wrapperState === 0){
        this.setState({wrapperState: 1});
        console.log("wrapperState:1");
      } else if(this.state.wrapperState === 1){
        if(this.state.validInput){
          this.setState({wrapperState: 2, textOnButton:"THANK YOU", error: false});
          axios.post('https://digitalsurfin.com/mail1', this.state).then(response => {
            if(response.data==="250 Message received"){
              console.log(response);
            } else {
              console.log(response);
            }
          })
          .catch(error => {
            console.log(error);
          });
        } else {
          this.setState({shake: true, error: true});
          setTimeout(() => this.setState({ shake: false}), 500);
        }
        
      } else if(this.state.wrapperState === 2){
      
        this.setState({wrapperState: 0, textOnButton:"Subscribe", email: ""});
      }


      if(window.innerWidth > 400){
        document.getElementById("signUp").focus();
      }

      // if(this.state.subscribe === false && this.state.validInput === true){
      //  var aliJe = false;
      //  this.setState({subscribe: !this.state.subscribe, textOnButton: "THANK YOU"});
        
      // }
    }
  }

  onFocus(){
    this.setState({placeholder: "name@example.com"});
  }

  validateEmail() {
    var re = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if(re.test(this.state.email)){
      this.setState({ validInput: true});
    }else{
      this.setState({ validInput: false});
    }
  }

  clicktehnical1(){
    this.setState({ active: 1});
  }
  clicktehnical2(){
    this.setState({ active: 2});
  }
  clicktehnical3(){
    this.setState({ active: 3});
  }

  handleClickGal(e){
    if(e.target.src !== undefined) {
      document.getElementById("galery12").style.display = "flex";
      document.getElementById("imgFull").src = e.target.src;
      this.setState({activeGal: e.target.src});
      setTimeout(() => {
        document.getElementById("galery12").style.opacity = 1;
      }, 100);
    } 
  }

  handleClose(){
    document.getElementById("galery12").style.opacity = 0;
    setTimeout(() => {
      document.getElementById("galery12").style.display = "none";
    }, 500);
  }

  handleNext(){
    var b = document.getElementsByClassName("galery")[0];
    for(var i=0; i<b.getElementsByTagName("img").length; i++){

      if(b.getElementsByTagName("img")[i].src === this.state.activeGal){

        if(i+1 === b.getElementsByTagName("img").length){
          document.getElementById("imgFull").src = b.getElementsByTagName("img")[0].src;
          this.setState({activeGal: b.getElementsByTagName("img")[0].src});
        } else {
          document.getElementById("imgFull").src = b.getElementsByTagName("img")[i+1].src;
          this.setState({activeGal: b.getElementsByTagName("img")[i+1].src});
          break;
        }
      }
    }
  }
  handleBack(){
    var b = document.getElementsByClassName("galery")[0];
    for(var i=0; i<b.getElementsByTagName("img").length; i++){

      if(b.getElementsByTagName("img")[i].src === this.state.activeGal){
        if(i === 0){
          document.getElementById("imgFull").src = b.getElementsByTagName("img")[b.getElementsByTagName("img").length-1].src;
          this.setState({activeGal: b.getElementsByTagName("img")[b.getElementsByTagName("img").length-1].src});
        } else {
          document.getElementById("imgFull").src = b.getElementsByTagName("img")[i-1].src;
          this.setState({activeGal: b.getElementsByTagName("img")[i-1].src});
        }
      }
    }
  }

  escFunction(event){
    if(event.keyCode === 37) {
      this.handleBack();
    } else if(event.keyCode === 39) {
      this.handleNext();
    } else if(event.keyCode === 27) {
      this.handleClose();
    }
  }
  componentDidMount(){
    document.addEventListener("keydown", this.escFunction, false);
  }
  componentWillUnmount(){
    document.removeEventListener("keydown", this.escFunction, false);
  }

  


  render() {
    const technical1State = this.state.active === 1 ? "carsTehnical1textActive" : "carsTehnical1text";
    const technical2State = this.state.active === 2 ? "carsTehnical1textActive" : "carsTehnical1text";
    const technical3State = this.state.active === 3 ? "carsTehnical1textActive" : "carsTehnical1text";
    const inputShake = this.state.shake ? styles.inputShake : null;
    const buttonWrapperState = this.state.wrapperState === 1 ? styles.buttonWrapperOpen : styles.buttonWrapperClose;
    const shadowBoxState = this.state.wrapperState === 1 ? styles.shadowBoxOpen : styles.shadowBoxClose;
    const buttonInputState = this.state.wrapperState === 1 ? styles.buttonInputOpen : styles.buttonInputClose;
    const buttonState = this.state.wrapperState === 1 ? styles.buttonOpen : styles.buttonClose;

    

  const { title } = this.props.page
  return (
    <div>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <Header />
      
      <div className="carsWrapperWrapper">
            

          <div className="carsWrapper">
            <div className="carsFlexWrapper">
              <img alt="tushek APEX" src="../assets/icons/tushekAPEX.png" className="carsImg2" />
              <div className="carsText3">BE THE FIRST TO HEAR THE HYPER NEWS!</div>

            </div>
            <div className={css(shadowBoxState, inputShake)}>
              <div className={css(buttonWrapperState)}>
                <a id="lala" onClick={this.handleClick} className={css(styles.button, buttonState)}>{this.state.textOnButton}</a>
                <input 
                  onClick={this.onFocus} 
                  
                  id="signUp" placeholder={this.state.placeholder} 
                  className={css(buttonInputState)} 
                  value={this.state.email}
                  onChange={e => this.setState({ email: e.nativeEvent.target.value })}
                  onKeyUp={this.validateEmail} 
                  onKeyDown={this.handleClickEnter}
                >
                  
                </input>
              </div>
              {this.state.error ? <div className={css(styles.errorText)}>This doesn't look like an email address.</div> : null}
            </div>
          </div>
          
          <CarWithPopups page={this.props.page} />

          <div className="carsWrapper">
            <div className="heritageTitle">TECHNICAL SPECIFICATIONS</div>
            <div className="carsTehnicalWrapper">
              <div onClick={this.clicktehnical1} className="carsTehnical1">
                <img alt="tehnical" className="carsTehnical1img" src="/assets/icons/tehnical1.png"/>
                <div className={technical1State}>HYBRID</div>
              </div>
              <div onClick={this.clicktehnical2} className="carsTehnical2">
                <img alt="tehnical" className="carsTehnical2img" src="/assets/icons/tehnical2.png"/>
                <div className={technical2State}>ELECTRIC</div>
              </div>
              <div onClick={this.clicktehnical3} className="carsTehnical3">
                <img alt="tehnical" className="carsTehnical3img" src="/assets/icons/tehnical3.png"/>
                <div className={technical3State}>PETROL</div>
              </div>
            </div>
            <div className="carsTehnicalWrapperText">
              {this.state.active === 1 ?
                <div>
                  <div className="carsTehnicalText">{this.props.page.hybrid}</div>
                  <div className="carsTehnicalSpecsWrapperWrapper">
                    <div className="carsTehnicalSpecsWrapper">
                      <div className="carsTehnicalSpecsTitle">
                        POWER
                      </div>
                      <div className="carsTehnicalSpecsText">
                        0,985MW (1.340 bhp)
                      </div>
                    </div>
                    <div className="carsTehnicalSpecsWrapper">
                      <div className="carsTehnicalSpecsTitle">
                        ACCELERATION
                      </div>
                      <div className="carsTehnicalSpecsText">
                        2.5s 0-100km/h (0-62mp/h)
                      </div>
                    </div>
                    <div className="carsTehnicalSpecsWrapper">
                      <div className="carsTehnicalSpecsTitle">
                        TORQUE
                      </div>
                      <div className="carsTehnicalSpecsText">
                        1.600Nm (1.180 lb-ft)
                      </div>
                    </div>
                    <div className="carsTehnicalSpecsWrapper">
                      <div className="carsTehnicalSpecsTitle">
                        TOP SPEED
                      </div>
                      <div className="carsTehnicalSpecsText">
                        380km/h (236mp/h)
                      </div>
                    </div>
                  </div>
                </div>
              :
                null
              }
              {this.state.active === 2 ?
                <div>
                  <div className="carsTehnicalText">{this.props.page.electric}</div>
                  <div className="carsTehnicalSpecsWrapperWrapper2">
                    <div className="carsTehnicalSpecsWrapper">
                      <div className="carsTehnicalSpecsTitle">
                        POWER
                      </div>
                      <div className="carsTehnicalSpecsText">
                        0,480MW (644 bhp)
                      </div>
                    </div>
                    <div className="carsTehnicalSpecsWrapper">
                      <div className="carsTehnicalSpecsTitle">
                        RANGE
                      </div>
                      <div className="carsTehnicalSpecsText">
                        50km (full charge)
                      </div>
                    </div>
                  </div>
                </div>
              :
                null
              }
              {this.state.active === 3 ?
                <div>
                  <div className="carsTehnicalText">{this.props.page.petrol}</div>
                  <div className="carsTehnicalSpecsWrapperWrapper2">
                    <div className="carsTehnicalSpecsWrapper">
                      <div className="carsTehnicalSpecsTitle">
                        POWER
                      </div>
                      <div className="carsTehnicalSpecsText">
                        0,505MW (677 bhp)
                      </div>
                    </div>
                    <div className="carsTehnicalSpecsWrapper">
                      <div className="carsTehnicalSpecsTitle">
                        TORQUE
                      </div>
                      <div className="carsTehnicalSpecsText">
                        690Nm (737.5 lb-ft)
                      </div>
                    </div>
                  </div>
                </div>
              :
                null
              }
            </div>
          </div>
        </div>
        <div className="heritageTitle">PHOTO GALLERY</div>
        <div className='sectionCarsGallery'>
          <div onClick={this.handleClickGal} className='containerHeritage galery'>
            <Content source={this.props.page.galery} />
          </div>
        </div>
        <div id="galery12" className='sectionHeritageGalleryFixed'>
          <div onClick={this.handleClose} className='HeritageLayer'></div>
          <img alt="back arrow" onClick={this.handleBack} id="imgFullw" className="arrowBack" src="assets/icons/arrowBack.png" />
          <img alt="close" onClick={this.handleClose} className="closeButton" src="assets/icons/closeButton.png" />
          <img alt="" id="imgFull" className="imgFull" src="" />
          <img alt="back next" onClick={this.handleNext} id="imgFullwe" className="arrowNext" src="assets/icons/arrowNext.png" />
        </div>
    </div>
  )
}}

const translateKeyframes = {
    '0%': { transform: 'translate(30px)', },
    '20%': { transform: 'translate(-30px)', },
    '40%': { transform: 'translate(15px)', },
    '60%': { transform: 'translate(-15px)', },
    '80%': { transform: 'translate(8px)', },
    '100%': { transform: 'translate(0px)', },
};

const breathing = {
    '0%': { transform: "scale(1)", },
    '30%': { transform: "scale(1.05)", },
    '100%': { transform: "scale(1)", },
};


const box = StyleSheet.create({
  wrapper:{
    minHeight:"calc(70vh - 650px)",
    width:"calc(100% - 80px)",
    margin:"0 auto",
    marginTop:100,
    '@media (max-width: 920px)': {
      
      marginTop:0,
    },
    '@media (max-width: 360px)': {
      width:"calc(100% - 40px)",
    },
  },
  flexWrapper:{
    display:"flex",
    backgroundSize:"cover",
    alignItems:"center",
    justifyContent:"center",
    flexDirection:"column",
    paddingBottom:50,
    paddingTop:50,
    '@media (max-width: 420px)': {
      marginTop:10,

    },
    '@media (max-width: 380px)': {
      marginTop:0,
    },
    '@media (max-width: 360px)': {
      marginTop:0,
      
    },
  },
  
  text3:{
    
    // '@media (max-width: 360px)': {
    //   fontSize:15,
    // },
  },
  
  img2:{
    
    

  },
});



const styles = StyleSheet.create({
  wrapper:{
    // backgroundImage: "url(../assets/pictures/tumb.png)",
    // backgroundPosition: "20% 50%",
    // backgroundSize:"cover",
    
  },



  button:{
    cursor:"pointer",
    fontWeight:500,
    fontSize:20,
    color:"#000",
    background:"#FBBC01",
    borderRadius:40,
    height:51,
    display:"block",
    textAlign:"center",
    lineHeight:2.3,
    float:"right",
    position:"absolute",
    right:5,
    textDecoration:"none",
    zIndex:1000,
    transition:"0.2s box-shadow ease-in",
    // '@media (max-width: 455px)': {
    //  height:40,
    //  fontSize:15,

    // }
  },
  buttonOpen:{
    width:140,
    height:40,
    lineHeight:2.3,
    fontSize:17,
    top:5,
    transition:"0.2s linear",
    '@media (max-width: 455px)': {
      width:110,
      fontSize:14,
      lineHeight:2.6,
    }
  },
  buttonClose:{
    width:210,
    height:40,
    fontSize:17,
    top:5,
    // '@media (max-width: 455px)': {
    //  width:120,
    // },
  },
  buttonInputOpen:{
    '::-webkit-input-placeholder': {
      color: '#FBBC01',
    },
    '::-moz-placeholder': {
      color: '#FBBC01',
    },
    ':-ms-input-placeholder': {
      color: '#FBBC01',
    },
    background:"#000",
    width:"calc(100%)",
    height:50,
  
    color: '#FBBC01',
    fontSize:15,
    border:"2px solid #FBBC01",
    borderRadius:40,
    padding:"0px 150px 0px 20px",
    outline:"none",
    transition:".4s cubic-bezier(0.55, 0.085, 0.48, 0);",
    
    '@media (max-width: 455px)': {
      fontSize:14,
      width:"100%",
      padding:"0px 110px 0px 20px",
    },
    '@media (max-width: 350px)': {
      fontSize:11,
    },
  },
  buttonInputClose:{
    color: '#FBBC01',
    border:"2px solid #FBBC01",
    position:"absolute",
    background:"#000",
    width:"100%",
    height:50,
    opacity:1,

    fontSize:20,
    borderRadius:40,
    padding:"0px 45px 0px 20px",
    outline:"none",
    // '@media (max-width: 455px)': {
    //  height:40,
    //  fontSize:15,
    // },
  },
  buttonWrapperOpen:{
    background:"transparent",

    left:-5,
    top:-5,
    height:50,
    width:"calc(100% + 10px)",
    position:"relative",
    
    animationName: breathing,
    animationDuration: "0.4s",
    animationDelay: ".3s",
    animationTimingFunction: "cubic-bezier(0.55, 0.085, 0.48, 0)",
    
    '@media (max-width: 455px)': {
      width:"calc(100% + 10px)",
    },
    
  },

  buttonWrapperClose:{
    background:"transparent",

    left:-5,
    top:-5,
    width:220,
    height:50,
    zIndex:20,
    position:"relative",
  },
  shadowBoxOpen:{
    zIndex:20,
    background:"transparent",
    transition:".4s cubic-bezier(0.55, 0.085, 0.48, 0)",
    boxShadow: "5px 5px 30px 5px rgba(48,95,129,0.15)",

    height:40,
    borderRadius:40,
    position:"relative",
    width:420,
    margin:"0 auto",
    marginTop:0,
    '@media (max-width: 910px)': {

      marginBottom:40,
    },
    '@media (max-width: 720px)': {
      margin:"0 auto",
    },
    '@media (max-width: 555px)': {
      width:"calc(100% - 20px)",
    },
  },
  shadowBoxClose:{
    background:"transparent",
    margin:"0 auto",
    marginTop:0,
    transition:".4s cubic-bezier(0.55, 0.085, 0.48, 0)",
    boxShadow: "5px 5px 30px 5px rgba(48,95,129,0.15)",
    height:40,
    borderRadius:40,
    position:"relative",
    width:210,
    '@media (max-width: 910px)': {
    },
    '@media (max-width: 720px)': {
      margin:"0 auto",
      marginBottom:40,
      marginTop:10,
    },

  },
  inputShake: {
    animationName: translateKeyframes,
    animationDuration: "0.4s",
    animationTimingFunction: "linear",
  },
  errorText:{
    marginTop:3,
    color:"#FBBC01",
    fontSize:12,
    marginLeft:10,
  },

  tehnicalWrapper:{
    
  },
  tehnical1:{
    
  },
  tehnical2:{
    textAlign:"center",
    transition:"0.1s ease-in-out",
    cursor:"pointer",
    ":hover":{
      transform:"scale(1.1)",
    }
  },
  tehnical3:{
    textAlign:"center",
    transition:"0.1s ease-in-out",
    cursor:"pointer",
    ":hover":{
      transform:"scale(1.1)",
    }
  },
  tehnical1img:{
    
  },
  tehnical2img:{
   
  },
  tehnical3img:{
    
  },
  tehnical1text:{
    
  },
  tehnical1textActive:{
    
  },
  tehnicalWrapperText:{
    

  },
  tehnicalText:{
    
  },
  tehnicalSpecsWrapperWrapper:{
    
  },
  tehnicalSpecsWrapperWrapper2:{
    
  },
  tehnicalSpecsWrapper:{
    
  },
  tehnicalSpecsTitle:{
    
   
  },
  tehnicalSpecsText:{

  },
  

});





// WEBPACK FOOTER //
// ./src/views/Cars.js